export default __webpack_public_path__ + "static/media/logo.38d4b73e.png";